var _defineProperty = require("/node_modules/@babel/runtime/helpers/defineProperty");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) : typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) : (global = global || self, factory(global.i18n = {}, global.React));
})(this, function (exports, React) {
  'use strict';

  React = React && React.hasOwnProperty('default') ? React['default'] : React;
  var LocaleContext = React.createContext();

  var LocaleProvider = function LocaleProvider(_ref) {
    var keys = _ref.keys,
        children = _ref.children;
    return React.createElement(LocaleContext.Provider, {
      value: keys
    }, children);
  };

  var useLocale = function useLocale(_ref2) {
    var key = _ref2.key;
    var ctx = React.useContext(LocaleContext);
    var language = window.navigator.language.split('-')[0];

    if (ctx) {
      return _defineProperty({}, key, ctx[language][key]);
    } else {
      throw new Error("No context keys found, be sure you're calling this function from inside a LocaleProvider");
    }
  };

  exports.LocaleProvider = LocaleProvider;
  exports.useLocale = useLocale;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});